import { gql } from '@urql/core'

export const queryKapGoalsWithFinalReports = gql`
  query fetchKapGoalsWithFinalReports($programId: Int!, $milestoneId: Int!) {
    kap_goal(where: { kap_program_id: { _eq: $programId } }, order_by: { sort_number: asc }) {
      id
      name
      description
      sort_number
      kap_goal_final_reports(where: { milestone_id: { _eq: $milestoneId } }) {
        rating
        reason
      }
    }
  }
`

export const queryKapGoalFinalReport = gql`
  query fetchKapGoalFinalReport($goalId: Int!, $milestoneId: Int!) {
    kap_goal_by_pk(id: $goalId) {
      id
      name
      sort_number
      kap_goal_final_reports(where: { milestone_id: { _eq: $milestoneId } }) {
        rating
        reason
      }
    }
  }
`

export const upsertKapGoalFinalReportMutation = gql`
  mutation upsertKapGoalFinalReport($object: kap_goal_final_report_insert_input!) {
    insert_kap_goal_final_report_one(
      object: $object
      on_conflict: { constraint: kap_goal_final_report_milestone_goal_uq, update_columns: [rating, reason] }
    ) {
      id
    }
  }
`
